import React from "react";
import {useSelector, useDispatch} from "react-redux";
import {useToasts} from "react-toast-notifications";

import loadingGif from '../../../../assets/images/loader.gif';
import {toggleExternalFinDoc, toggleExternalPayment} from "../../../../store/actions/admission";

const ToggleExternalCompletionLinks = ({admission}) => {
    const dispatch = useDispatch();
    const {toggleExternalCompletionIds} = useSelector(state => state.admission);
    const {selectedHospital} = useSelector(state => state.auth);
    const {addToast} = useToasts();

    if (!selectedHospital.externallyCompleted_testMode) {
        return null;
    }

    const isToggling = toggleExternalCompletionIds.indexOf(admission.id) > -1;

    const finDocText = admission.externalFinDocCompleted
        ? "[Test] Unmark financial documents externally completed"
        : "[Test] Mark financial documents externally completed";

    const paymentText = admission.externalPaymentCompleted
        ? "[Test] Unmark payment externally completed"
        : "[Test] Mark $1001.01 payment externally completed";

    const handleToggleFinDoc = () => {
        dispatch(toggleExternalFinDoc(admission, addToast));
    };

    const handleTogglePayment = () => {
        dispatch(toggleExternalPayment(admission, addToast));
    };

    if (isToggling) {
        return (
            <>
                <a className="dropdown-item disabled pointer">
                    <img src={loadingGif} alt="loading" />{finDocText}
                </a>
                <a className="dropdown-item disabled pointer">
                    <img src={loadingGif} alt="loading" />{paymentText}
                </a>
            </>
        );
    }

    return (
        <>
            <a className="dropdown-item pointer" onClick={handleToggleFinDoc}>
                {finDocText}
            </a>
            <a className="dropdown-item pointer" onClick={handleTogglePayment}>
                {paymentText}
            </a>
        </>
    );
}

export default ToggleExternalCompletionLinks;
